import classnames from 'classnames';

import ButtonUI from 'components/atoms/ButtonUI';

import soundOn from 'images/icons/sound.png';
import soundOff from 'images/icons/sound-off.png';
import { useSoundOn } from 'models/mainSite';

import styles from './index.css';

export interface SoundBtnProp {
    className?: string;
    soundOn: boolean;
}

const SoundBtn: React.FC<SoundBtnProp> = ({ className }) => {
    const [soundOnState, { setSoundOn }] = useSoundOn();

    return (
        <ButtonUI
            className={classnames(styles.soundBtn, className)}
            small
            icon={soundOnState ? soundOn : soundOff}
            onClick={() => {
                setSoundOn(!soundOnState);
            }}
            shadow
        />
    );
};

export default SoundBtn;
